import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "table-auto border-separate",
  style: {
      'border-spacing': 0,
    }
}
const _hoisted_2 = { class: "border-b" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { class: "border-r bg-clip-padding bg-white lg:sticky left-0" }, null, -1)
const _hoisted_4 = {
  colspan: "128",
  class: "text-left bg-white"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { ref: "tableBody" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VariantsRow = _resolveComponent("VariantsRow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        _createElementVNode("th", {
          class: "border-r bg-clip-padding bg-white lg:sticky",
          style: _normalizeStyle({ left: _ctx.offsetWidth + 'px' })
        }, null, 4),
        _createElementVNode("th", _hoisted_4, _toDisplayString(`${_ctx.$t('variants.words')} 1-${Object.keys(_ctx.variants.reference).length}`), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", {
          class: "border-r bg-clip-padding bg-white lg:sticky left-0",
          ref: "firstCol"
        }, _toDisplayString(_ctx.$t('variants.work')), 513),
        _createElementVNode("th", {
          class: "border-r bg-clip-padding bg-white lg:sticky",
          style: _normalizeStyle({ left: _ctx.offsetWidth + 'px' })
        }, _toDisplayString(_ctx.$t('variants.reader')), 5),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variants.reference, (value, key) => {
          return (_openBlock(), _createElementBlock("th", {
            key: key,
            id: 'word-column-' + key,
            class: "bg-white text-center"
          }, _toDisplayString(key), 9, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayRows, (v, index) => {
        return (_openBlock(), _createBlock(_component_VariantsRow, {
          verseCount: Object.keys(_ctx.variants.reference).length,
          key: v.reading_id,
          variant: v,
          odd: index % 2 === 1,
          freezeWidth: _ctx.offsetWidth
        }, null, 8, ["verseCount", "variant", "odd", "freezeWidth"]))
      }), 128))
    ], 512)
  ]))
}